import type { FaireProductEntity } from "../../entity_types/product";

export const p_t4mmbysxt9: FaireProductEntity = {
  token: "p_t4mmbysxt9",
  type: "product",
  name: "Easily Distracted By Dogs Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/c9188b3ce1877b61ed11448fadb2c955caf4d1c81c2caf49d74ea982f8437f18.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9887edf597b5648393b9903281476851c5c3ce09ce43c0990b8927a21acbdec8.jpeg",
    "https://cdn.faire.com/fastly/0ea90b362c5ced4565c12d6dd83eaa83f1021ac18174f6134d183605d5469500.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/657ac2f5e4175e050aa717fae5b5056aa9cfec5f903b637c7c1ec175af813933.jpeg",
    "https://cdn.faire.com/fastly/4176c9914ca9a16d191197a2c193471f4081af748c1faf36e8344c9ce0520b30.jpeg",
    "https://cdn.faire.com/fastly/018185557fae25043e47389ea46c762d0fe1abd0d4574590f058ac4b7ba28ff1.jpeg",
    "https://cdn.faire.com/fastly/d535b92691372612bcc9b32b0037fdac89ec40bcda59d0d0e6853f0d2319954f.jpeg"
  ],
  priceDollars: 6.75,
  description: "For anyone who’s ever been emotionally hijacked by making eye contact for any amount of time with any dog, ever.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:12.017Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
